import styled from 'styled-components';

export const ConsultationInfo = styled.div.attrs({
  className: 'flex flex-row items-end justify-between w-full gap-1 flex-wrap',
})``;
